import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#DD9A05",
        d: "M37.0103 22.4644H23.2619c-1.7822-2.0877-4.4301-3.4117-7.4344-3.4117-5.2447 0-9.522 4.1246-9.7766 9.2675C6 28.6257 6 28.8803 6 29.1349c1.0693 8.5546 10.4386 11.457 18.6876 11.457 7.3325 0 13.7484-3.6663 17.1091-9.0129.5601-.7638-4.7864-9.1146-4.7864-9.1146"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFB901",
        d: "M42.0001 32.2414c0-7.1797-5.8049-12.9846-12.9846-12.9846s-12.9846 5.8049-12.9846 12.9846v.3564c1.1712 4.9393 6.2123 8.0963 11.9153 7.8926 8.3509-.2546 13.3919-3.768 14.003-7.7398.0509-.2546.0509-.4073.0509-.5092"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#FFC950",
        d: "M29.1173 20.3261c3.4591 0 6.2632-2.8041 6.2632-6.2631 0-3.4591-2.8041-6.2632-6.2632-6.2632-3.459 0-6.2631 2.8041-6.2631 6.2632 0 3.459 2.8041 6.2631 6.2631 6.2631"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#EFA92B",
        d: "M15.9808 20.0718c2.7279 0 4.9393-2.2113 4.9393-4.9392s-2.2114-4.9392-4.9393-4.9392c-2.7278 0-4.9392 2.2114-4.9392 4.9392 0 2.7279 2.2114 4.9392 4.9392 4.9392"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#916100",
        d: "M30.8491 32.9033c-.4073.2037-.8656.3055-1.4257.3055-.5092 0-.9675-.1019-1.3749-.2546s-.7638-.4074-1.0693-.662c-.3055-.3055-.5601-.662-.7129-1.0693-.1527-.4074-.2546-.8656-.2546-1.3748s.1019-.9675.2546-1.3749.4074-.7638.7129-1.0693.662-.5092 1.1203-.662c.4073-.1528.8656-.2546 1.3748-.2546.4583 0 .8656.1018 1.3239.2546s.7638.4074 1.0693.7129l-1.0184 1.0184c-.1527-.2037-.3564-.3565-.5601-.4583-.2546-.1018-.4583-.1527-.7129-.1527q-.3819 0-.7638.1527c-.2036.1018-.4073.2546-.5601.4074-.1527.1527-.3055.3564-.3564.611q-.1528.3819-.1528.7638c0 .3055.0509.5602.1528.8148s.2037.4582.3564.611.3565.3055.5601.4074.4583.1527.7129.1527c.3055 0 .5601-.0509.8147-.2037.2037-.1018.4074-.2545.5602-.4582l1.0693 1.0184c-.3565.3055-.7129.611-1.1203.7638"
    }, "4")
], "AppCustomers", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
